module.exports = __webpack_public_path__ + "img/beneficio-produtos.e438344c.svg";